//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import Cuid from '@models/Cuid';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { Normalized } from '@utils/normalize';

export const Like2BuyV2ModerationStatus = {
  Archived: 'Archived',
  NeedsProducts: 'NeedsProducts',
  NeedsProductsAndRights: 'NeedsProductsAndRights',
  NeedsRights: 'NeedsRights',
  Pinned: 'Pinned',
  Published: 'Published',
} as const;

export type Like2BuyV2ModerationStatus =
  keyof typeof Like2BuyV2ModerationStatus;

export const Like2BuyV2ModerationItemFilter = {
  ActionNeeded: 'ActionNeeded',
  AllMedia: 'AllMedia',
  Archived: 'Archived',
  Published: 'Published',
} as const;

export type Like2BuyV2ModerationItemFilter =
  | keyof typeof Like2BuyV2ModerationItemFilter;

export interface IMediaItemWithLike2BuyV2Status {
  item: IMlsMediaItem;
  status: Like2BuyV2ModerationStatus;
}

export interface ILike2BuyV2MediaItem extends IMlsMediaItem {
  like2BuyV2ModerationStatus: Like2BuyV2ModerationStatus;
}

export type NormalizedLike2BuyV2Items = Normalized<ILike2BuyV2MediaItem, Cuid>;

export interface ILike2BuyV2ItemsSearchParams {
  status?: Like2BuyV2ModerationItemFilter;
  offset?: number;
  limit?: number;
}

export interface ILike2BuyV2ItemsSearchResult {
  mediaItems: IMediaItemWithLike2BuyV2Status[];
  totalCount: number;
}

export interface ILike2BuyV2ItemsSearchResponse {
  data: ILike2BuyV2ItemsSearchResult;
}

export interface ILike2BuyV2MaterializeItemsRequestBody {
  cuids: Cuid[];
}

export interface ILike2BuyV2MaterializeItemsResponse {
  data: {
    items: IMediaItemWithLike2BuyV2Status[];
  };
}

export interface IAddLike2BuyV2ItemsRequestBody {
  cuids: Cuid[];
  like2BuySortTimestamps?: Like2BuyV2SortTimestamps;
  shouldSetPublishedTimeToCurrentTime?: boolean;
  consistentWrite?: boolean;
}

export interface IAddLike2BuyV2ItemsResponse {
  data: {
    alreadyAddedItems: IMediaItemWithLike2BuyV2Status[];
  };
}

export interface IArchiveLike2Buyv2ItemsRequestBody {
  cuids: Cuid[];
  consistentWrite: boolean;
}

export interface ILike2BuyV2PinItemsRequestBody {
  cuids: Cuid[];
  consistentWrite: boolean;
}

export type Like2BuyV2SortTimestamps = Record<Cuid, number>;

export interface IGetPinnedLike2BuyV2ItemsResponse {
  data: {
    pinnedItems: IMediaItemWithLike2BuyV2Status[];
  };
}
